import { forwardRef } from 'react';
import LogoVideo from '@/components/LogoVideo';
import { useLanguage } from '@/contexts/LanguageContext';
import { ExternalLink } from 'lucide-react';

const Footer = forwardRef<HTMLElement>(function Footer(_, ref) {
  const { t } = useLanguage();

  return (
    <footer ref={ref} className="bg-foreground py-12">
      <div className="container-max px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <LogoVideo className="h-10 w-auto rounded" ariaLabel="Dr.Vet AI logo" />
            <span className="text-sm text-background/60">{t.footer.tagline}</span>
          </div>
          <div className="text-center md:text-right">
            <a
              href="https://wvac2026-tokyo.com/en/program.html"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm text-background/80 font-medium hover:text-background transition-colors"
            >
              {t.footer.wva}
              <ExternalLink size={14} />
            </a>
            <p className="text-xs text-background/50 mt-1">{t.footer.rights}</p>
          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
